import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Checkbox} from "@irati/ui/src/FormItem"

export const PROPERTY = "preferences.includeActionBoard"

/**
 * Get the checkbox value
 *
 * @param survey
 * @returns {boolean}
 * @private
 */
const _getPropertyValue = (survey) => !!get(survey, PROPERTY, false) || false

const IncludeActionBoard = ({survey, onChange}) => {
  return (
    <Checkbox name={PROPERTY} onChange={() => onChange(survey, PROPERTY, !_getPropertyValue(survey))} checked={_getPropertyValue(survey)}>
      Include action board?
    </Checkbox>
  )
}

IncludeActionBoard.propTypes = {
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

IncludeActionBoard.defaultProps = {}

export default IncludeActionBoard
